import Vue from 'vue';
import Router from 'vue-router';
import { routes } from '../src/routes';


Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes,
});


// function getRoutesList(routes, pre) {
//   return routes.reduce((array, route) => {
//     const path = `${pre}${route.path}`;

//     if (route.path !== '*') {
//       array.push(path);
//     }

//     if (route.children) {
//       array.push(...getRoutesList(route.children, `${path}/`));
//     }

//     return array;
//   }, []);
// }

// function getRoutesXML() {
//   const list = getRoutesList(router.options.routes, 'https://dev-bloomuser.ekbana.info')
//     .map(route => `<url><loc>${route}</loc></url>`)
//     .join('\r\n');
//   return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
//     ${list}
//   </urlset>`;
// }
// console.log(getRoutesXML());

const DEFAULT_TITLE = 'マイページ | Bloomキャリア登録';
router.beforeEach((to, from, next) => {
  const check = Vue.auth.isAuthenticated();
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
  if (to.path.startsWith('/unsubscribe/')) {
    return next();
  }
  // console.log(to, from);
  if (to.meta.guest && check) return router.push('/');
  if (to.meta.auth && !check) return router.push('/login');
  return next();
});


export default router;
